import { render } from "./ZoomableGallery.vue?vue&type=template&id=1647b59c"
import script from "./ZoomableGallery.vue?vue&type=script&lang=js"
export * from "./ZoomableGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__